import {createAction, props} from '@ngrx/store';
import {Organization, UpdateOrganizationParameters} from '../../../services/api/organizations/models/organization.model';

export const updateOrganization = createAction(
  '[UpdateOrganization] Update Organization',
  props<UpdateOrganizationParameters>()
);

export const updateOrganizationSuccess = createAction(
  '[UpdateOrganization] Update Organization Success',
  props<{ data: Organization }>()
);

export const updateOrganizationFailure = createAction(
  '[UpdateOrganization] Update Organization Failure',
  props<{ error: unknown }>()
);

export const clearUpdateOrganizationState = createAction(
  '[UpdateOrganization] Clear Update Organization State'
);
